import React, { useEffect, useState } from "react";
import { IoCallOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { IoLocation } from "react-icons/io5";
import { PiShoppingBagOpenFill } from "react-icons/pi";
import "./Footer.css";
import { AiOutlineCaretRight } from "react-icons/ai";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoTwitter } from "react-icons/io5";
import { IoLogoInstagram } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa";
import { FaBehance } from "react-icons/fa";
import { Icon } from "@iconify/react";
import Logo from "../Logo/Logo";
import { Axios } from "../Helpers/Axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios.get("/blogs").then((data) => setData(data.data.data.slice(-3)));
  }, []);

  return (
    <footer className="Footer">
      <div className="content">
        
        <div className="getIn">
          <h4 className="header">{t("Get in touch")}</h4>

          <div className="item">
            <Icon icon="fluent:call-32-regular" width="12" height="12" className="icon" />
            <span>(+20)1005400514</span>
          </div>

          <div className="item">
            <Icon icon="fluent:call-32-regular" width="12" height="12" className="icon" />
            <span>(+20)1005400514</span>
          </div>

          <div className="item">
            <AiOutlineMail className="icon mt-1" />
            <span>Info@Sunmedagency.com</span>
          </div>

          <div className="item">
            <Icon icon="fluent:location-12-filled" width="12" height="12" className="icon" />
            <span>70 Abu Hayan Al Tawhid,AlHay Alsabea, Nasr city, Egypt</span>
          </div>

          <div className="item">
            <PiShoppingBagOpenFill className="icon" />
            <span>Sunday - Thursday from 9am - 5pm</span>
          </div>
        </div>

        <div className="details">
          <h4 className="header">{t("Our tools")}</h4>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>ROAS {t("calculator")}</span></div>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>CPC {t("calculator")}</span></div>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>(CTR) {t("calculator")}</span></div>
        </div>

        <div className="details">
          <h4 className="header">{t("Our services")}</h4>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>{t("Media Production")}</span></div>
          <div className="item"><AiOutlineCaretRight /><span>{t("Social media marketing")}</span></div>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>{t("Media buying")}</span></div>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>{t("SEO")}</span></div>
          <div className="item"><AiOutlineCaretRight className="icon" /><span>{t("Website development")}</span></div>
        </div>

        <div className="blogs">
          <h4 className="header">{t("Blogs")}</h4>

          {data.map((b, index) => (
            <Link key={index} className="blog" to={`/single-blog/${b.uuid}`}>
              <div className="img">
                <img src={b.cover} alt="blog" loading="lazy" />
              </div>
              <div className="text">
                <p>{b.title}</p>
                <p className="flex items-center gap-1 ">
                  <Icon icon="fe:calendar" width="16" height="16" className="icon" />
                  <span>
                    {new Date(b.created_at).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                </p>
              </div>
            </Link>
          ))}

        </div>
      </div>
  {/* النص الجديد المضاف */}
  <p className="item ownership-text mt-3 text-center">
          {t(
            "This website is owned and operated by SUN G for Investment, Advertising Services and Industries, the legal owner of the brand “SunMed Agency”. Commercial Registration No.: 235112"
          )}
        </p>
      <div className="identity">

        <div className="logo">
          <Logo class="md:w-[100px] w-[60px]" />
        </div>

        <div className="flex items-center justify-center gap-2">
          <div className="icon-container"><FaFacebookF className="icon" /></div>
          <div className="icon-container"><IoLogoTwitter className="icon" /></div>
          <div className="icon-container"><IoLogoInstagram className="icon" /></div>
          <div className="icon-container"><FaLinkedinIn className="icon" /></div>
          <div className="icon-container"><FaBehance className="icon" /></div>
        </div>

        <a
          target="_blank"
          href="https://mail.google.com/mail/?view=cm&fs=1&to=info@Sunmedagency.com"
        >
          <p>Info@Sunmedagency.com</p>
        </a>


      </div>
      
    </footer>
  );
};

export default Footer;
